import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { useTranslation } from '@lt/localization';
import { Button, CurrencyFormat } from '@lt/components';

import ReviewsList from './ReviewsList';
import Paper from '../Paper';
import Rating from '../../containers/Rating';

const baseCls = 'lt-hotel-reviews';

const ReviewsDesktop = ({ isRatingExists, hotelName, hotelLink, price }) => {
  const { t } = useTranslation();

  return (
    <div className={baseCls}>
      <h2 className="like-h2">
        {t('hotel.reviews.title')} <HotelTitle>{hotelName}</HotelTitle>
      </h2>
      <ReviewsHeading>
        <Link href={hotelLink}>
          <PriceButton primary size="flex">
            {t('hotel.reviews.selectTour')}
            {price ? <CurrencyFormat prefix=" от " value={price} /> : null}
          </PriceButton>
        </Link>
      </ReviewsHeading>
      <div className={`${baseCls}__row`}>
        <div className={`${baseCls}__list`}>
          <div className={`${baseCls}__items`}>
            <ReviewsList />
          </div>
        </div>
        {isRatingExists && (
          <div className={`${baseCls}__rating`}>
            <Paper>
              <Rating />
            </Paper>
          </div>
        )}
      </div>
    </div>
  );
};

const HotelTitle = styled.span`
  font-weight: normal;
`;

const ReviewsHeading = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row-reverse;
  margin-bottom: 8px;
`;

const PriceButton = styled(Button)`
  height: 38px;
  min-height: 38px;
`;

const Link = styled.a`
  text-decoration: none;
  margin-top: 15px;
`;

ReviewsDesktop.propTypes = {
  isRatingExists: PropTypes.bool.isRequired,
  hotelName: PropTypes.string.isRequired,
};

export default ReviewsDesktop;
